import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['inputWrapper', 'buttonWrapper', 'input'];
  timeout = null;

  connect() {
    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
    this.boundResetTimeout = this.resetTimeout.bind(this);
    this.boundStartTimeout = this.startTimeout.bind(this);
  }

  toggle() {
    const isHidden = this.inputWrapperTarget.classList.contains('hidden');
    if (isHidden) {
      this.showInput();
    } else {
      this.hideInput();
    }
  }

  showInput() {
    this.inputWrapperTarget.classList.remove('hidden');
    this.inputTarget.focus();
    this.inputTarget.value = '';

    document.addEventListener('click', this.boundHandleClickOutside);
    this.inputTarget.addEventListener('input', this.boundResetTimeout);
    this.inputTarget.addEventListener('focus', this.clearTimeout);
    this.inputTarget.addEventListener('blur', this.boundStartTimeout);

    this.startTimeout();
  }

  hideInput() {
    this.inputWrapperTarget.classList.add('hidden');
    this.inputTarget.value = '';

    document.removeEventListener('click', this.boundHandleClickOutside);
    this.inputTarget.removeEventListener('input', this.boundResetTimeout);
    this.inputTarget.removeEventListener('focus', this.clearTimeout);
    this.inputTarget.removeEventListener('blur', this.boundStartTimeout);

    this.clearTimeout();
  }

  startTimeout = () => {
    this.clearTimeout();
    this.timeout = setTimeout(this.hideInput.bind(this), 3000);
  };

  resetTimeout() {
    this.startTimeout();
  }

  clearTimeout = () => {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  };

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideInput();
    }
  }
}
